import { useEffect }   from 'react';
import { Platform }    from 'react-native';
import PropTypes       from 'prop-types';

const EmbeddedScript = ({ id, script }) => {
    useEffect(() => {
        if (!Platform.OS.equals('web') || !script) {
            return;
        }

        const cleanedScript    = script.replaceAll('<p>', '').replaceAll('</p>', '')
                                       .replaceAll('<span>', '').replaceAll('</span>');

        if (script?.length > 0) {
            const scriptElement = document.createElement('script');
            scriptElement.id = id;
            scriptElement.innerHTML = cleanedScript;
            scriptElement.type = 'text/javascript';

            document.getElementsByTagName('body')[0].appendChild(scriptElement);
        }
    }, []);

    return null;
};

EmbeddedScript.propTypes = {
    id: PropTypes.string.isRequired,
    script: PropTypes.string.isRequired
};

export default EmbeddedScript;
